module.exports = __webpack_public_path__ + "img/screen_1.43d80d9e.png";